// @flow
export type ContextData = {
    isGlobalPersonnel: boolean,
    product: string,
    toTranslationKey: (product: string, path: string) => string
};

/**
 * Returns the context data which is set in the initialValue to the JsonForm.
 * Not that this context data is not actual settings value.
 * @param {*} ctx JsonForm context
 * @returns ContextData
 */
const ctxToSettingsContextData = (ctx: $FixMe): ContextData => {
    return ctx.core.data?.context || {};
};

export default ctxToSettingsContextData;
